var _effectorFileName = "/src/widgets/layouts/main/for-whom-our-lessons/for-whom-our-lessons.tsx";
import { useTranslation } from 'next-i18next';
import { BADGE_LIST } from '@/widgets/layouts/main/constants/badges';
import { Article } from '@/shared/components/article';
import { Marquee } from '@/shared/components/marquee';
import { Badge } from '@/shared/components/ui/badge';
export const ForWhomOurLessons = () => {
  const {
    t
  } = useTranslation('for-whom-lessons');
  return <Article withContainer={false}>
      <div className="container mb-8">
        <h2 className="header-h2">{t('title')}</h2>
      </div>

      <Marquee pauseOnHover>
        {BADGE_LIST.map((badgeKey, index) => <Badge key={index} size="sm">
            {t(badgeKey)}
          </Badge>)}
      </Marquee>
    </Article>;
};